module.exports = __webpack_public_path__ + "static/media/game-cards-example.268c3823.gif";